import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  button: {
    paddingRight: theme.spacing(3),
  },
}));
